import { QueryHookOptions, useQuery } from '@apollo/client';

import { GET_CONSULTATION_BY_TEACHER } from './queries';
import type { ConsultingEvent } from './types';

export const useConsultationsByTeacher = (options?: QueryHookOptions) =>
  useQuery<{
    consultation: ConsultingEvent[];
  }>(GET_CONSULTATION_BY_TEACHER, options);
